/*jshint loopfunc: true */
define('editor/edit/layers/edit/markers',['plugins/http', 'durandal/app', 'jquery', 'knockout', 'knockout-mapping', 'tinycolorpicker'], function (http, app, $, ko, komapping) {
    var viewmodel = function () {
        var self = this;

        self.name = ko.observable();
        self.backup = null;
        self.backupLayers = [];
        
        self.icons = ko.observableArray([]);

        self.choosingIcon = ko.observable(false);
        
        self.selectedIcon = ko.observable();
        self.selectedIconOld = ko.observable();
        self.iconVisible = ko.observable();
        self.selectedTextSize = ko.observableArray([]);
        self.selectedAlignment = ko.observableArray([]);
        self.labelTextColor = ko.observable();
        self.labelShadowColor = ko.observable();
        self.labelVisible = ko.observable(true);
        self.isAutoNumber = ko.observable(false);
        self.autoNumberTextSelected = ko.observable(false);
        self.autoNumberIcons = ko.observableArray([]);
        self.autoNumberText = ko.observable('');
        self.autoNumberButtonText = ko.computed(function() {
            return self.isAutoNumber() ? 'Remove group auto-numbered markers' : 'Convert group to auto-numbered markers';
        });

        // svg prop defaults
        self.iconColour = ko.observable('#FFFFFF');
        self.paddleColour = ko.observable('#808080');
        self.paddleVisible = ko.observable(false);
        
        self.selectedIconSize = ko.observableArray(['normal']);

        self.activate = function (editorMapId, group, layers, backToListFunc) {
            self.editorMapId = editorMapId;
            self.group = group;
            self.backup = group;
            self.name(group.name());
            self.exit = backToListFunc;
            self.layers = layers;
            
            self.backupChildLayers();
            
            self.getIcons()
                .then(self.processIcons)
                .fail(app.showError);
            
            // defaults: use first marker layer in group
            var firstLayer = ko.utils.arrayFirst(self.layers, function (item) {
                return item.type() !== 'Directions';
            });

            self.selectedIcon(firstLayer.state().selectedicon());
            self.selectedIconOld(firstLayer.state().selectedicon());
            self.iconVisible(firstLayer.state().visibilityOptions.iconVisible());
            self.selectedTextSize.push(firstLayer.state().textSize());
            self.selectedAlignment.push(firstLayer.state().textAlign());
            self.labelTextColor(firstLayer.state().labelTextColor());
            self.labelShadowColor(firstLayer.state().textShadowColour());
            self.labelVisible(firstLayer.state().visibilityOptions.labelVisible());
            self.isAutoNumber(firstLayer.state().isAutoNumber ? firstLayer.state().isAutoNumber() : false);
            self.autoNumberText(self.getAutoNumberText(self.layers));

            // set svg controls with first marker properties
            self.iconColour(firstLayer.state().iconColour());
            self.paddleColour(firstLayer.state().paddleColour());
            self.paddleVisible(firstLayer.state().visibilityOptions.paddleVisible());

            self.selectedIconSize.push(firstLayer.state().iconSize());

            self.changes = ko.computed(function () {
                // want to be notified of changes to these properties
                return self.selectedIcon() +
                  self.selectedTextSize()[0] +
                  self.selectedAlignment()[0] +
                  self.labelTextColor() +
                  self.labelShadowColor() +
                  self.labelVisible() +
                  self.iconVisible() +

                  self.isAutoNumber() +

                  // svg controls
                  self.iconColour() +
                  self.paddleVisible() +
                  self.paddleColour() +
                  self.selectedIconSize()[0];
            });

            self.changes.subscribe(function () {
                // update child layers observables and notify
                var layersLen = self.layers.length;

                for (var i = 0; i < layersLen; i++) {
                    var layer = self.layers[i];

                    // directions can be grouped with markers, but we only apply changes to marker layers
                  if (layer.type() === 'Directions') {
                    continue;
                  }

                  layer.state().selectedicon(self.selectedIcon());
                  layer.state().textSize(self.selectedTextSize()[0]);
                  layer.state().textAlign(self.selectedAlignment()[0]);
                  layer.state().labelTextColor(self.labelTextColor());
                  layer.state().visibilityOptions.labelVisible(self.labelVisible());
                  layer.state().textShadowColour(self.labelShadowColor());
                  layer.state().isAutoNumber = ko.observable(self.isAutoNumber());
                  layer.state().visibilityOptions.iconVisible = ko.observable(self.iconVisible());

                  if (self.isAutoNumber()) {
                      var number = i > 8 ? i + 1 : '0' + (i + 1);
                      var numberedIcon = self.selectedIcon().replace('01.svg', number + '.svg');

                      layer.state().selectedicon(numberedIcon);
                  }

                  // add svg state properties
                  layer.state().iconColour(self.iconColour());
                  layer.state().visibilityOptions.paddleVisible(self.paddleVisible());
                  layer.state().paddleColour(self.paddleColour());
                  layer.state().iconSize(self.selectedIconSize()[0]);
                }

                app.trigger("layers:updated", self.layers);
            });

            app.on('layers:drawing', function () {
                self.cancelCommand();
            });
        };
        
        self.compositionComplete = function () {
            // initialise jquery plugins etc
            var picker = $('.color-picker-text').tinycolorpicker();
            var pickerShadow = $('.color-picker-shadow').tinycolorpicker();
            var pickerIcon = $('.color-picker-icon').tinycolorpicker();
            var pickerPaddle = $('.color-picker-marker').tinycolorpicker();

            picker.data().plugin_tinycolorpicker.setColor(self.labelTextColor());
            pickerShadow.data().plugin_tinycolorpicker.setColor(self.labelShadowColor());
            pickerIcon.data().plugin_tinycolorpicker.setColor(self.iconColour());
            pickerPaddle.data().plugin_tinycolorpicker.setColor(self.paddleColour());

            picker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelTextColor(newColour);
            });
            
            pickerShadow.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelShadowColor(newColour);
            });

            pickerIcon.bind("change", function () {
              var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
              self.iconColour(newColour);
            });

            pickerPaddle.bind("change", function () {
              var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
              self.paddleColour(newColour);
            });
        };
        
        self.detached = function () {
            if (self.isDirty) {
                self.cancelCommand();
            }
        };
        
        self.getIcons = function () {
            var url = '/api/editor/icons';

            return http.get(url);
        };

        self.chooseIcon = function () {
            self.choosingIcon(true);

            return false;
        };

        self.processIcons = function (response) {
            // group icons into category heirarchy
            var icons = response.data.icons;
            var categories = ko.utils.arrayMap(icons, function (icon) {
                return icon.categoryName;
            });

            self.autoNumberIcons(ko.utils.arrayFilter(icons, function(icon) {
                return icon.categoryName === 'Numbered' && icon.filePath.indexOf('01.svg') !== -1;
            }));

            var uniqueCategories = ko.utils.arrayGetDistinctValues(categories).sort();
            var categoriesLen = uniqueCategories.length;

            for (var i = 0; i < categoriesLen; i++) {
                var catName = uniqueCategories[i];
                var groupedIconsByCategory = {
                    name: catName,
                    icons: ko.observableArray([])
                };

                var categoryIcons = ko.utils.arrayFilter(icons, function (icon) {
                    return icon.categoryName === catName;
                });

                ko.utils.arrayPushAll(groupedIconsByCategory.icons(), categoryIcons);

                self.icons.push(groupedIconsByCategory);
            }
        };

        self.getAutoNumberText = function (layers) {
            var text = '';
            for (var i = 0; i < layers.length; i++) {
                text += ((i + 1) + ' - ' + layers[i].state().html() + '\n');
            }
            return text;
        };
        
        self.backupChildLayers = function () {
            var layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];
                if (layer.state().labelText) {
                    layer.state().labelText(layer.state().labelText().unescapeNewLines());
                }
                if (layer.state().html) {
                    layer.state().html(layer.state().html().unescapeNewLines());
                }

                self.backupLayers.push(ko.toJS(layer));
            }
        };
        
        self.setSelectedIcon = function (icon) {
            self.selectedIcon(icon.filePath);
            self.choosingIcon(false);

            return false;
        };
        
        self.toggleIconVisibility = function () {
            self.iconVisible(!self.iconVisible());
        };

        self.toggleAutoNumber = function () {
            if (self.layers.length > 15) {
                return app.showMessage('You cannot have more than 15 markers in an auto-numbered list');
            }

            self.isAutoNumber(!self.isAutoNumber());

            if (self.isAutoNumber()) {
                self.selectedIconOld(self.selectedIcon());
                self.setSelectedIcon(self.autoNumberIcons()[0]);
            } else {
                self.selectedIcon(self.selectedIconOld());
            }
        };

        self.selectAutoNumberText = function() {
            self.autoNumberTextSelected(true);
            var textarea = $('#auto-number-text'),
                message = $('#copy-message');
            message.text('Press Ctrl+C to copy text!');

            textarea.focus();
            textarea.select();
            message.show();

            textarea.bind({
                'copy': function () {
                    message.text("Copied!");
                }
            });
        };

        self.saveCommand = function () {
            self.group.name(self.name());

            self.save()
                .then(function () {
                    self.isDirty = false;
                    self.exit();
                })
                .fail(app.showError);
        };

        self.cancelCommand = function () {
            // revert to initial layer state, for each layer
            var layersLen = self.layers.length,
                layer,
                backup,
                mappedState;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];
                backup = self.backupLayers[i];
                mappedState = komapping.fromJS(backup.state);

                delete mappedState['__ko_mapping__'];

                layer.state(mappedState);
            }
            
            app.trigger("layers:updated", self.layers);
            self.group.name(self.backup.name());
            self.isDirty = false;
            self.exit();
        };

        self.save = function () {
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: self.group.id(),
                    groupName: self.group.name(),
                    groupCollapsed: self.group.isCollapsed(),
                    childLayerStates: {}
                },
                layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];

                if (layer.state().isAutoNumber) {
                    layer.state().isAutoNumber(self.isAutoNumber());
                }

                data.childLayerStates[layer.id()] = ko.toJS(layer.state());
            }

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});

